import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=30135920&scoped=true"
import script from "./addressManage.vue?vue&type=script&lang=js"
export * from "./addressManage.vue?vue&type=script&lang=js"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=30135920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30135920",
  null
  
)

export default component.exports